import React from 'react';
import { FormField } from './form-field';
import { FormContext } from '../../../../contexts/form-context';
import { FieldValidationContext } from '../../../../contexts/field-validation-context';
import { FormFieldsContext } from '../../contexts/form-fields-context';
import { FieldActionsContext } from '../../../../contexts/field-actions-context';
import { FormViewContext } from '../../../../contexts/form-view-context';
export const createFormFields = _ref => {
  let {
    form,
    errors,
    values,
    onFieldChange,
    onBlur,
    onFocus,
    FieldLayout,
    formSchema,
    validateFields,
    fields,
    fieldActions
  } = _ref;
  return form.fields.map(formField => {
    const component = /*#__PURE__*/React.createElement(FormContext.Provider, {
      value: formSchema
    }, /*#__PURE__*/React.createElement(FormFieldsContext.Provider, {
      value: fields
    }, /*#__PURE__*/React.createElement(FieldActionsContext.Provider, {
      value: fieldActions
    }, /*#__PURE__*/React.createElement(FieldValidationContext.Provider, {
      value: {
        validateFields
      }
    }, /*#__PURE__*/React.createElement(FormViewContext.Provider, {
      value: form
    }, /*#__PURE__*/React.createElement(FormField, {
      key: formField.id,
      field: formField,
      values: values,
      errors: errors,
      onFieldChange: onFieldChange,
      onBlur: onBlur,
      onFocus: onFocus,
      FieldLayout: FieldLayout
    }))))));
    return {
      id: formField.id,
      fieldType: formField.fieldType,
      component,
      layout: formField.layout
    };
  }).filter(item => !!item);
};
//# sourceMappingURL=create-form-fields.js.map